import React from 'react';
import { Switch } from '@headlessui/react';
import ToggleSwitch from './ToggleSwitch';
function classNames(...classes) {
    return classes.filter(Boolean).join(' ');
}
export default function ToggleSwitchGroup({ enabled, onChange, children }) {
    return (React.createElement(Switch.Group, { as: "div", className: "flex items-center" },
        React.createElement(ToggleSwitch, { enabled: enabled, onChange: onChange, className: classNames(enabled ? 'bg-green-cm' : 'bg-gray-200', 'relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2') }),
        React.createElement(Switch.Label, { as: "span", className: "ml-3 text-sm text-gray-500" }, children)));
}
